import { useSetJaneDeviceId } from '@jane/monolith/hooks/useSetJaneDeviceId';

export const SetJaneDeviceId = () => {
  useSetJaneDeviceId();

  return null;
};
